import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { getConferenceTimestamp } from '../../base/conference/functions';
import { getLocalizedDurationFormatter } from '../../base/i18n/dateUtil';
import { ConferenceTimerDisplay } from './index';
const ConferenceTimer = ({ textStyle }) => {
    const startTimestamp = useSelector(getConferenceTimestamp); // The server's start time
    const [timerValue, setTimerValue] = useState(getLocalizedDurationFormatter(0));
    const interval = useRef(undefined);
    const lastStartTimestamp = useRef(startTimestamp);
    const [startTime, setStartTime] = useState(undefined); // Client-side start time
    /**
     * Sets the current state values that will be used to render the timer.
     *
     * @returns {void}
     */
    const setStateFromClientTime = useCallback(() => {
        if (!startTime) {
            return;
        }
        const currentTime = new Date().getTime();
        const elapsedTime = currentTime - startTime;
        const localizedTime = getLocalizedDurationFormatter(elapsedTime);
        setTimerValue(localizedTime);
    }, [startTime]);
    /**
     * Start conference timer.
     *
     * @returns {void}
     */
    // const startTimer = useCallback(() => {
    //     if (!interval.current && startTimestamp) {
    //         setStateFromUTC(startTimestamp, new Date().getTime());
    //         interval.current = window.setInterval(() => {
    //             setStateFromUTC(startTimestamp, new Date().getTime());
    //         }, 1000);
    //     }
    // }, [ startTimestamp, interval ]);
    /**
     * Start conference timer.
     *
     * @returns {void}
     */
    // const startTimer = useCallback(() => {
    //     if (!interval.current && startTimestamp) {
    //         const localJoinTime = new Date().getTime();
    //         const initialTimerValue = Math.max(0, localJoinTime - startTimestamp); // Prevent negative value
    //         setTimerValue(getLocalizedDurationFormatter(initialTimerValue));
    //         interval.current = window.setInterval(() => {
    //             const currentValueUTC = new Date().getTime();
    //             const timerMsValue = Math.max(0, currentValueUTC - startTimestamp); // Prevent negative value
    //             setTimerValue(getLocalizedDurationFormatter(timerMsValue));
    //         }, 1000);
    //     }
    // }, [startTimestamp, interval]);
    // const startTimer = useCallback(() => {
    //     if (!interval.current && startTimestamp) {
    //         const localJoinTime = new Date().getTime();
    //         const initialDifference = localJoinTime - startTimestamp;
    //         // Start the timer from the elapsed time if it's positive, otherwise 0.
    //         let initialTimerValue = Math.max(0, initialDifference);
    //         setTimerValue(getLocalizedDurationFormatter(initialTimerValue));
    //         interval.current = window.setInterval(() => {
    //             // Continuously recalculate the elapsed time to keep the timer accurate
    //             const currentValueUTC = new Date().getTime();
    //             const timerMsValue = Math.max(0, currentValueUTC - startTimestamp);
    //             setTimerValue(getLocalizedDurationFormatter(timerMsValue));
    //         }, 1000);
    //     }
    // }, [startTimestamp, interval]);
    // const startTimer = useCallback(() => {
    //     if (!interval.current && startTimestamp) {
    //         const localJoinTime = new Date().getTime();
    //         const initialDifference = localJoinTime - startTimestamp;
    //         // Start the timer from the elapsed time if it's positive, otherwise force it to start from 0
    //         let initialTimerValue = Math.max(0, initialDifference);
    //         setTimerValue(getLocalizedDurationFormatter(initialTimerValue));
    //         interval.current = window.setInterval(() => {
    //             // Simulate the timer progressing even if local time is behind UTC
    //             initialTimerValue += 1000; // Increase timer by 1 second per interval
    //             setTimerValue(getLocalizedDurationFormatter(initialTimerValue));
    //         }, 1000);
    //     }
    // }, [startTimestamp, interval]);
    const startTimer = useCallback(() => {
        if (!interval.current) { // No need for startTimestamp or any calculations
            const localJoinTime = new Date().getTime();
            interval.current = window.setInterval(() => {
                const elapsedTime = new Date().getTime() - localJoinTime;
                setTimerValue(getLocalizedDurationFormatter(elapsedTime));
            }, 1000);
        }
    }, [interval]);
    /**
     * Stop conference timer.
     *
     * @returns {void}
     */
    const stopTimer = useCallback(() => {
        if (interval.current) {
            clearInterval(interval.current);
            interval.current = undefined;
        }
        setTimerValue(getLocalizedDurationFormatter(0)); // Reset the timer to 00:00
    }, []);
    // Start the timer as soon as `startTimestamp` changes or the component mounts
    useEffect(() => {
        if (startTimestamp) {
            startTimer();
        }
        else {
            stopTimer();
        }
        return () => stopTimer();
    }, [startTimestamp, startTimer, stopTimer]);
    if (!startTimestamp) {
        return null; // If no start timestamp is provided, don't render the timer
    }
    return (React.createElement(ConferenceTimerDisplay, { textStyle: textStyle, timerValue: timerValue }));
};
export default ConferenceTimer;
